import React from 'react';
import { ACCORDION_DETAILS_TYPOGRAPHY_VARIANT, ACCORDION_HORIZONTAL_SPACING, ACCORDION_VERTICAL_SPACING } from '../const';
import { AccordionOwnerState } from '../model';
import { styled } from '../../../theme';

export const AccordionDetails = styled('div', {
  name: 'AccordionDetails',
  slot: 'Details',
})<{ ownerState: AccordionOwnerState }>(({ theme, ownerState }) => {
  const commonStyles = {
    color: theme.palette['brand gray'],
  };

  if (ownerState.color === 'white') {
    commonStyles.color = theme.palette.white;
  }

  return {
    ...(ownerState.isDetailsPassedAsPlainText ? theme.typography[ACCORDION_DETAILS_TYPOGRAPHY_VARIANT] : undefined),
    ...commonStyles,
    padding: theme.spacing(0, ACCORDION_HORIZONTAL_SPACING, ACCORDION_VERTICAL_SPACING),
  };
});
